<template>
  <dynamic-modal
      :show-footer="false"
      name="image-preview-modal">
    <template #body>
      <preloader class="image-preview-loader" :showPreloader="isLoading" />
      <img v-show="!isLoading" @load="onImageLoad" class="image-preview" :src="imageSrc" alt="image-preview">
    </template>
  </dynamic-modal>
</template>
<script>
import Vue from "vue";
import DynamicModal from "@/components/__new_ui_kit/Modal/DynamicModal";
import Preloader from "@/components/Preloader/Preloader";

export default Vue.extend({
  components: {Preloader, DynamicModal},
  data() {
    return {isLoading: true}
  },
  props: {
    imageSrc: {type: String, required: true}
  },
  methods: {
    onImageLoad() {
      this.isLoading = false
    }
  }
})
</script>
<style scoped lang="scss">;
  .image-preview-modal {
    .image-preview-loader {
      padding: 0;
      height: 200px;
      .preloader {
        margin: 0;
      }
    }
    .image-preview {
      height: auto;
      width: 100%;
    }
  }

</style>